import React from 'react';

import './FormDivider.scss';

export const FormDivider = () => <div className="form-divider" />;
